import { cn } from '@massilia/ui'
import { Luggage } from 'lucide-react'

import type { LuggageFilterValue } from '@/lib/schemas/flight-results-search.schema'

import { useLuggageFilter } from './use-luggage-filter'

/**
 * Raccourcis affichés dans la barre mobile. Même sémantique que la sidebar :
 * « 1 » = 1 bagage en soute ET PLUS. La 4ᵉ valeur du filtre (« Sans bagage »)
 * n'y figure pas — elle reste accessible depuis « Plus de filtres », et aucun
 * segment n'apparaît sélectionné lorsqu'elle est active.
 */
const QUICK_OPTIONS: LuggageFilterValue[] = ['0', '1', '2']

interface BaggageQuickFilterProps {
  disabled?: boolean
}

export function BaggageQuickFilter({ disabled = false }: BaggageQuickFilterProps) {
  const { setLuggage, value } = useLuggageFilter()

  return (
    <div
      aria-label="Bagages en soute inclus"
      className={cn(
        'border-input flex h-11 w-full items-center gap-1 rounded-xl border bg-white pr-1 pl-2',
        disabled && 'pointer-events-none opacity-50'
      )}
      role="group"
    >
      <Luggage aria-hidden className="size-4 shrink-0 text-brand-600" />
      {QUICK_OPTIONS.map((option) => {
        const active = value === option
        return (
          <button
            aria-label={`${option} bagage${option === '2' ? 's' : ''} et plus`}
            aria-pressed={active}
            className={cn(
              'h-9 flex-1 rounded-lg text-sm font-medium transition-colors',
              active ? 'bg-brand-600 text-white' : 'text-gray-light-700 hover:bg-muted'
            )}
            disabled={disabled}
            key={option}
            onClick={() => {
              setLuggage(option)
            }}
            type="button"
          >
            {option}
          </button>
        )
      })}
    </div>
  )
}
